import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AssinaturaService } from '../../../core/services/assinatura.service';
import { MessageService } from 'primeng/api';
import { Assinatura } from '../../../core/models/assinatura';

@Component({
  selector: 'app-assinatura-form',
  templateUrl: './assinatura-form.component.html',
  styleUrls: ['./assinatura-form.component.scss'],
})
export class AssinaturaFormComponent implements OnInit {
  form!: FormGroup;
  editMode = false;
  id?: string | null;

  constructor(
    private fb: FormBuilder,
    private service: AssinaturaService,
    private router: Router,
    private route: ActivatedRoute,
    private message: MessageService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      empresaId: ['', Validators.required],
      nomeEmpresa: [''],
      plano: ['', Validators.required],
      dataInicio: [null],
      schema: ['', Validators.required],
    });

    this.id = this.route.snapshot.paramMap.get('id');
    if (this.id && this.id !== 'cadastrar') {
      this.editMode = true;
      this.service.getById(this.id).subscribe((res: Assinatura) => this.form.patchValue(res));
    }
  }

  salvar() {
    if (this.form.invalid) return;
    const payload = this.form.value;
    if (this.editMode && this.id) {
      this.service.update(this.id, payload).subscribe({
        next: () => {
          this.message.add({ severity: 'success', summary: 'Sucesso', detail: 'Atualizado' });
          this.router.navigate(['/assinaturas']);
        },
        error: () => this.message.add({ severity: 'error', summary: 'Erro', detail: 'Falha' }),
      });
    } else {
      this.service.create(payload).subscribe({
        next: () => {
          this.message.add({ severity: 'success', summary: 'Sucesso', detail: 'Criado' });
          this.router.navigate(['/assinaturas']);
        },
        error: () => this.message.add({ severity: 'error', summary: 'Erro', detail: 'Falha' }),
      });
    }
  }

  cancelar() {
    this.router.navigate(['/assinaturas']);
  }
}
